module.exports = __webpack_public_path__ + "static/stromee-app-2-f9934c30bfc0b26c87c3b544ab255087.png";